<!-- 交易记录查询 -->
<template>
  <div class="transaction-record">
    <!-- 搜索 -->
    <div class="search-wrap">
      <e-search
        class="e-search"
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleSearch"
        @handleReset="handleClear"
        :count="10"
      ></e-search>
    </div>
    <!-- 列表 -->
    <div class="table-content">
      <table-list :loading="loading" :table-data="tableData" :table-label="tableLabel">
        <template #index="slotScope">
          <span>
            {{ (listQuery.pageNum - 1) * listQuery.pageSize + slotScope.scope.$index + 1 }}
          </span>
        </template>
        <template v-slot:amount="slot">
          {{
            slot.scope.row.amount ? (slot.scope.row.amount / 100).toFixed(2) : slot.scope.row.amount
          }}
        </template>
        <template v-slot:operation="slot">
          <el-button
            v-if="slot.scope.row.status === 1"
            @click="handleUpdate(slot.scope.row)"
            type="text"
            size="small"
          >
            查询更新
          </el-button>
        </template>
      </table-list>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :page-size="listQuery.pageSize"
          :total="total"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="查询更新"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <div class="msg">
          您是否需要根据查询结果更新支付单状态？
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableList from "@/modules/projectA/components/common/e-table-list";
import ESearch from "@/modules/projectA/components/common/e-search";
import Api from "@/modules/projectA/api/pay/index";
import _ from "lodash";
export default {
  data() {
    return {
      dialogVisible: false,
      cloneListQuery: {},
      listQuery: {
        payerUserName: null,
        payeeUserName: null,
        businessNo: null,
        businessFlowNo: null,
        originalBusinessFlowNo: null,
        status:null,
        pageNum: 1,
        pageSize: 10,
      },
      loading: false,
      tableData: [{}],
      total: 0,

      fieldList: [
        { label: "付款企业", type: "input", value: "payerUserName" },
        { label: "收款企业", type: "input", value: "payeeUserName" },
        { label: "订单编号", type: "input", value: "businessNo" },
        { label: "交易流水号", type: "input", value: "businessFlowNo" },
        { label: "原交易流水号", type: "input", value: "originalBusinessFlowNo" },
        {label: "支付单类型", type: "select", value: "businessType", placeholder: "请选择配送状态", list: "businessTypeList",},
        {label: "支付单状态", type: "select", value: "status", placeholder: "请选择支付单状态", list: "statusList",},
      ],
      listTypeInfo: {
        /* PAY(1,"支付"),RETURN(2,"退款"),TOP_UP(3,"充值"),WITHDRAW_CASH(4,"提现"), */
        businessTypeList: [
          { id: 1, name: "支付" },
          { id: 2, name: "退款" },
          { id: 3, name: "充值" },
          { id: 4, name: "提现" },
        ],
        statusList:[
          { id: null, name: "全部状态" },
          { id: 1, name: "处理中" },
          { id: 2, name: "处理成功" },
          { id: 3, name: "处理失败" },
        ],
      },
      tableLabel: [
        { label: "序号", align: "center", slot: "index", fixed: "left", width: "80px" },
        {
          label: "交易流水号",
          param: "businessFlowNo",
          align: "center",
          width: "180",
          fixed: "left",
        },
        {
          label: "原交易流水号",
          param: "originalBusinessFlowNo",
          align: "center",
          width: "260",
        },
        {
          label: "支付渠道",
          param: "paymentChannelDesc",
          align: "center",
          width: "120",
        },
        {
          label: "支付单类型",
          param: "businessTypeDesc",
          align: "center",
          width: "120",
        },
        {
          label: "支付方式",
          param: "paymentTypeDesc",
          align: "center",
          width: "120",
        },
        {
          label: "支付单状态",
          param: "statusDesc",
          align: "center",
          width: "100",
        },
        {
          label: "付款企业",
          param: "payerUserName",
          align: "center",
          width: "220",
        },
        {
          label: "收款企业",
          param: "payeeUserName",
          align: "center",
          width: "220",
        },
        {
          label: "订单编号",
          param: "businessNo",
          align: "center",
          width: "150",
        },
        {
          label: "金额(元)",
          param: "amount",
          align: "center",
          width: "120",
          slot: "amount",
        },
        {
          label: "创建时间",
          param: "createTime",
          align: "center",
          width: "160",
        },
        {
          label: "支付完成时间",
          param: "completeTime",
          align: "center",
          width: "160",
        },
        {
          label: "操作人",
          param: "createByName",
          align: "center",
          width: "100",
        },
        {
          label: "操作时间",
          param: "updateTime",
          align: "center",
          width: "160",
        },
        { label: "操作", align: "center", slot: "operation", width: "100", fixed: "right" },
      ],
      paramsRow: {},
    };
  },
  components: { ESearch, TableList },
  mounted() {
    this.cloneListQuery = _.cloneDeep(this.listQuery);
    this.getList(this.listQuery);
  },
  methods: {
    handleUpdate(val) {
      this.paramsRow = { ...val };
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async handleSubmit() {
      try {
        const {
          businessFlowNo,
          businessModule,
          businessNo,
          operatorByName,
          paymentRecordId,
        } = this.paramsRow;
        const params = {
          businessFlowNo,
          businessModule,
          businessNo,
          operatorByName,
          paymentRecordId,
        };
        const res = await Api.refresh(params);
        if (+res.code === 200) {
          this.$message.success("刷新成功");
          this.dialogVisible = false;
          this.getList(this.listQuery);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getList(params) {
      try {
        const res = await Api.transactionRecordPage(params);
        const data = res.data;
        this.tableData = [...data.records];
        this.total = data.total;
      } catch (err) {
        console.log(err);
      }
    },
    handleSearch(val) {
      this.listQuery = { ...val };
      this.listQuery.pageNum = 1;
      console.log(this.listQuery);
      if (val.time) {
        this.listQuery.startTime = val.time[0];
        this.listQuery.endTime = val.time[1];
      }

      this.getList(this.listQuery);
    },
    handleClear() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    },
    handleSizeChange(pageSize) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = pageSize;
      this.getList(this.listQuery);
    },
    handleCurrentChange(pageNum) {
      this.listQuery.pageNum = pageNum;
      this.getList(this.listQuery);
    },
  },
};
</script>
<style lang="scss" scoped>
.msg {
  margin-top: 20px;
}
.transaction-record {
  padding: 10px;
  width: 100%;
  background: #fff;
  .tab-content {
    display: flex;
    align-items: center;
    .tab-btn {
      width: 234px;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      // border: 1px solid #DCDFE6;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      padding: 12px 20px;
      font-size: 14px;
      // border-radius: 4px;
      border-top: 1px solid #d9d9d9;
      border-left: 1px solid #d9d9d9;
      &:last-child {
        border-right: 1px solid #d9d9d9;
      }
      &.active {
        position: relative;
        background: #f4f7ff;
        color: #0064c8;
        border-top: 2px solid #0064c8;
        border-bottom: 0;
        z-index: 10;
      }
    }
  }
  .search-wrap {
    padding: 10px;
    width: 100%;
    border: 1px solid #d9d9d9;
    position: relative;
    top: -1px;
    .search-form {
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        flex: 0 0 316px;
      }
      .el-input {
        width: 200px;
      }
    }
    .search-btn {
      text-align: center;
    }
  }

  .table-content {
    margin-top: 10px;
  }
  .handle-btn {
    text-align: right;
    padding: 10px 0;
  }
  .pagination {
    margin-top: 12px;
    text-align: right;
  }
}
</style>
